<template>
    <v-expansion-panels class="mt-3" multiple v-model="expandedPanels">
        <v-expansion-panel>
            <v-expansion-panel-title>
                <div class="d-flex align-center justify-space-between w-100">
                    <span>Istoric livrări</span>

                    <!-- Buton normal pe desktop -->
                    <v-btn
                        v-if="
                            !$vuetify.display.smAndDown &&
                            showDeliveryRequestButton
                        "
                        color="primary"
                        variant="text"
                        density="comfortable"
                        @click.stop="handleDeliveryRequest"
                    >
                        Solicitare livrare
                    </v-btn>

                    <!-- Meniu pe mobil -->
                    <v-menu
                        v-if="
                            $vuetify.display.smAndDown &&
                            showDeliveryRequestButton
                        "
                        offset-y
                    >
                        <template #activator="{ props }">
                            <v-btn
                                v-bind="props"
                                icon
                                variant="plain"
                                color="black"
                                @click.stop
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item @click="handleDeliveryRequest">
                                <v-list-item-title
                                    >Solicitare livrare</v-list-item-title
                                >
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
                <template
                    v-for="(request, index) in deliveryRequests"
                    :key="request.id"
                >
                    <v-row class="mb-3">
                        <v-col cols="12">
                            <span class="text-subtitle-1 font-weight-bold"
                                >{{ index + 1 }}.</span
                            >
                            <span class="font-weight-bold">
                                {{
                                    getDeliveryStatusLabel(
                                        request.status,
                                        request.id
                                    )
                                }}
                            </span>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" lg="3">
                            <v-text-field
                                :model-value="
                                    new Date(
                                        request.delivery_date
                                    ).toLocaleDateString('ro-RO')
                                "
                                label="Dată livrare"
                                variant="outlined"
                                readonly
                                prepend-inner-icon="mdi-calendar"
                                hide-details
                                density="compact"
                                :disabled="
                                    request.status === 'approved' ||
                                    request.status === 'pending_for_partial' ||
                                    request.status === 'rejected'
                                "
                            />
                        </v-col>

                        <v-col
                            v-if="partialDeliveries[request.id]"
                            cols="12"
                            md="6"
                            lg="3"
                        >
                            <v-menu
                                v-model="suggestedDateMenus[request.id]"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                                :disabled="
                                    request.status === 'approved' ||
                                    request.status === 'pending_for_partial'
                                "
                            >
                                <template v-slot:activator="{ props }">
                                    <v-text-field
                                        v-model="
                                            formattedSuggestedDates[request.id]
                                        "
                                        label="Sugestie livrare integrală"
                                        :disabled="
                                            request.status === 'approved' ||
                                            request.status ===
                                                'pending_for_partial'
                                        "
                                        v-bind="props"
                                        prepend-inner-icon="mdi-calendar"
                                        hide-details
                                        density="compact"
                                        variant="outlined"
                                    />
                                </template>

                                <v-date-picker
                                    v-model="suggestedDeliveryDates[request.id]"
                                    @update:model-value="
                                        (val) =>
                                            updateSuggestedDate(
                                                val,
                                                request.id,
                                                request
                                            )
                                    "
                                    hide-actions
                                    color="primary"
                                    locale="ro-ro"
                                    :min="minDate"
                                    show-adjacent-months
                                    :readonly="
                                        request.status === 'approved' ||
                                        request.status === 'pending_for_partial'
                                    "
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col
                            cols="12"
                            :md="partialDeliveries[request.id] ? 12 : 6"
                            :lg="partialDeliveries[request.id] ? 6 : 9"
                        >
                            <v-textarea
                            v-if="partialDeliveries[request.id]"
                                :readonly="!userPermissions.greenHouseSolarManagement.canEditClient"
                                v-model="deliveryDescriptions[request.id]"
                                label="Descriere"
                                variant="outlined"
                                auto-grow
                                rows="1"
                                hide-details
                                density="compact"
                                :disabled="
                                    request.status === 'approved' ||
                                    request.status === 'pending_for_partial' ||
                                    request.status === 'rejected'
                                "
                            />
                        </v-col>
                    </v-row>

                    <v-row v-if="userPermissions.greenHouseSolarManagement.canEditClient">
                        <v-col cols="12" md="6" lg="6">
                            <v-checkbox
                                v-model="partialDeliveries[request.id]"
                                label="Livrare parțială"
                                density="compact"
                                hide-details
                                @change="markPartialDeliveryTrue(request.id)"
                                :disabled="
                                    request.status === 'approved' ||
                                    request.status === 'pending_for_partial'
                                "
                        /></v-col>
                        <v-col
                            cols="12"
                            md="6"
                            lg="6"
                            v-if="request.status !== 'approved'"
                            class="d-flex justify-end ga-10 align-end"
                        >
                            <v-btn
                                color="success"
                                @click="() => approveDelivery(request)"
                                :disabled="
                                    request.status === 'approved' ||
                                    request.status === 'rejected' ||
                                    request.status === 'pending_for_partial'
                                "
                            >
                                Aprobat
                            </v-btn>
                            <v-btn
                                color="danger"
                                @click="openRejectDialog"
                                :disabled="
                                    request.status === 'approved' ||
                                    request.status === 'rejected' ||
                                    request.status === 'pending_for_partial' ||
                                    partialDeliveries[request.id]
                                "
                            >
                                Respins
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>

                    <v-row
                        v-if="
                            request.status === 'approved' &&
                            request.id === deliveryRequests.at(-1)?.id &&
                            isLastRequestApproved
                        "
                    >
                        <v-col cols="12" md="6" lg="4">
                            <v-btn
                                color="primary"
                                @click="handleDeliveryRequest"
                            >
                                Solicită altă livrare
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>

    <DeliveryRequestDialog
        v-model="showRejectDialog"
        :mode="dialogMode"
        :initial-date="
            dialogMode === 'rejected' ? deliveryRequest?.delivery_date : null
        "
        description="Vă rugăm introduceți data la care doriți să se trimită marfa din depozitul SISTEMA."
        date-label="Data de livrare"
        @confirm="handleDialogConfirm"
    />
</template>

<script>
import apiClient from "@/utils/apiClient";
import DeliveryRequestDialog from "@/components/common/DeliveryRequestDialog.vue";
import { showAlertModal, sendDeliveryEmail } from "@/utils/utils";
import { mapGetters } from "vuex";

export default {
    name: "DeliveryRequestCard",
    components: { DeliveryRequestDialog },
    props: {
        client: {
            type: Object,
        },
       
    },
    data() {
        return {
            minDate: new Date().toISOString().split('T')[0], // format YYYY-MM-DD
            expandedPanels: [],
            deliveryRequests: [],
            deliveryDescriptions: {},
            partialDeliveries: {},
            suggestedDeliveryDates: {},
            formattedSuggestedDates: {},
            suggestedDateMenus: {},
            showRejectDialog: false,
            dialogInitialDate: null,
            dialogMode: "create",
        };
    },
    computed: {
        ...mapGetters(["userPermissions"]),
        showDeliveryRequestButton() {
            return (
                Array.isArray(this.deliveryRequests) &&
                this.deliveryRequests.length === 0 &&
                this.hasAdvanceInvoice
            );
        },
        /**
         * Counts how many delivery requests have been approved for the current client.
         * @returns {number}
         */
        approvedDeliveryCount() {
            // This assumes only the latest delivery is fetched
            return this.deliveryRequest?.status === "approved" ? 1 : 0;
        },
        /**
         * Checks if the last delivery request is approved.
         * Used to conditionally render the "Solicită altă livrare" button.
         * @returns {boolean}
         */
        isLastRequestApproved() {
            const lastRequest = this.deliveryRequests.at(-1);
            return lastRequest?.status === "approved";
        },
        hasAdvanceInvoice() {
            return this.client.attachments?.some(
                (att) => att.document_type === "advance_invoice"
            );
        },
        formattedDeliveryDate() {
            const date = this.deliveryRequest?.delivery_date;
            if (!date) return "";
            return new Date(date).toLocaleDateString("ro-RO");
        },
    },
    async mounted() {
        await this.fetchDeliveryRequest();
    },
    methods: {
        /**
         * Converts a date to ISO format if it exists.
         * @param {string | Date | null} date - The date to convert.
         * @returns {string | null} - The ISO string or null if the date is invalid.
         */
        toISODate(date) {
            if (!date) return null;
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const day = String(d.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        /**
         * Fetches the most recent delivery request for the current client.
         * Only the latest request (by creation date) is stored in state.
         *
         * @returns {Promise<void>}
         */
        async fetchDeliveryRequest() {
            try {
                const contentTypesRes = await apiClient.get(
                    "/api/content-types/"
                );
                const contentTypeId =
                    contentTypesRes.data.greenhousesolarclient;

                const res = await apiClient.get(
                    `/api/products-delivery-request/${contentTypeId}/${this.client.id}/`
                );
                if (Array.isArray(res.data) && res.data.length > 0) {
                    // Sortare opțională dacă backendul nu garantează ordinea
                    // Sortează toate requesturile cronologic (de la vechi la nou)
                    this.deliveryRequests = res.data.sort(
                        (a, b) =>
                            new Date(a.created_at) - new Date(b.created_at)
                    );

                    // Păstrează și ultima solicitare, dacă mai ai nevoie de ea separat
                    this.deliveryRequest = this.deliveryRequests.at(-1);

                    this.deliveryDescription = this.deliveryRequest.description;
                    this.partialDeliveries = {};
                    this.deliveryRequests.forEach((req) => {
                        this.partialDeliveries[req.id] = !!req.partial_delivery;
                        this.deliveryDescriptions[req.id] =
                            req.description || "";
                    });
                    this.deliveryRequests.forEach((req) => {
                        if (req.suggested_delivery_date) {
                            this.suggestedDeliveryDates[req.id] = new Date(
                                req.suggested_delivery_date
                            )
                                .toISOString()
                                .substr(0, 10);

                            this.formattedSuggestedDates[req.id] = new Date(
                                req.suggested_delivery_date
                            ).toLocaleDateString("ro-RO");
                        }

                        this.suggestedDateMenus[req.id] = false;
                    });
                } else {
                    this.deliveryRequest = null;
                }
            } catch (err) {
                console.error(
                    "Eroare la fetch-ul solicitării de livrare:",
                    err
                );
                this.deliveryRequest = null;
            }
        },
        /**
         * Opens dialog to select new delivery date before rejecting the request.
         */

        handleDeliveryRequest() {
            this.dialogMode = "create";
            this.showRejectDialog = true;
            this.newDeliveryDate = null;

        },
        /**
         * Opens the rejection dialog for a delivery request.
         *
         * - Sets the dialog mode to `"rejected"` to indicate rejection context.
         * - Displays the rejection dialog by setting `showRejectDialog` to true.
         * - Pre-fills the date field with the current delivery request date, if available.
         */

        openRejectDialog() {
            this.dialogMode = "rejected";
            this.showRejectDialog = true;
            this.newDeliveryDate = this.deliveryRequest?.delivery_date || null;
        },
        /**
         * Handles dialog confirm for both 'create' and 'reevaluate' delivery requests.
         *
         * @param {string} isoDate - ISO-formatted date selected in the dialog
         */
        async handleDialogConfirm(isoDate) {
            const contentTypesRes = await apiClient.get("/api/content-types/");
            const contentTypeId = contentTypesRes.data.greenhousesolarclient;

            try {
                if (this.dialogMode === "create") {
                    const res = await apiClient.post(
                        `/api/products-delivery-request/${contentTypeId}/${this.client.id}/`,
                        {
                            status: "pending",
                            delivery_date: isoDate,
                        }
                    );

                    this.deliveryRequest = res.data;
                    this.deliveryRequests.push(res.data);
                    this.deliveryRequests.sort(
                        (a, b) =>
                            new Date(a.created_at) - new Date(b.created_at)
                    );

                    this.isPartialDelivery = false;

                    await sendDeliveryEmail({
                        scenario: "agent_requested",
                        client_id: this.client.id,
                        actor: "agent",
                        description: this.deliveryRequest?.description || null,
                        partial_delivery:
                            this.partialDeliveries[this.deliveryRequest.id] ||
                            false,
                        test: false,
                    });
                    showAlertModal(
                        this.$store,
                        "Solicitarea de livrare a fost creată.",
                        "success",
                        5000
                    );
                    this.$toast?.success(
                        "Solicitarea de livrare a fost creată."
                    );
                    this.expandedPanels = [0];

                } else if (this.dialogMode === "rejected") {
                    // === PATCH EXISTING DELIVERY REQUEST ===
                    await apiClient.patch(
                        `/api/products-delivery-request/${contentTypeId}/${this.client.id}/`,
                        {
                            status: "rejected",
                            delivery_date: isoDate,
                            description:
                                this.deliveryDescriptions[
                                    this.deliveryRequest.id
                                ] || "",
                        }
                    );

                    this.deliveryRequest.status = "rejected";
                    this.deliveryRequest.delivery_date = isoDate;
                    await sendDeliveryEmail({
                        scenario: "admin_rejected",
                        client_id: this.client.id,
                        actor: "admin",
                        description: this.deliveryRequest?.description || null,
                        partial_delivery:
                            this.partialDeliveries[this.deliveryRequest.id] ||
                            false,
                        test: false,
                    });

                    showAlertModal(
                        this.$store,
                        "Solicitarea de livrare a fost respinsă cu noua dată.",
                        "danger",
                        5000
                    );
                    this.$toast?.success(
                        "Solicitarea de livrare a fost respinsă cu noua dată."
                    );
                }
            } catch (err) {
                console.error("Eroare la procesarea solicitării:", err);
                this.$toast?.error(
                    "A apărut o eroare la salvarea solicitării."
                );
            } finally {
                this.showRejectDialog = false;
            }
        },

        /**
         * Confirms rejection and updates delivery request with new date.
         *
         * @param {string} isoDate - Date selected in YYYY-MM-DD format
         */
        async confirmRejection(isoDate, request) {
            if (!this.deliveryRequest?.id) return;

            const formattedDate =
                typeof isoDate === "string"
                    ? isoDate.slice(0, 10)
                    : new Date(isoDate).toISOString().split("T")[0];

            try {
                const contentTypesRes = await apiClient.get(
                    "/api/content-types/"
                );
                const contentTypeId =
                    contentTypesRes.data.greenhousesolarclient;

                await apiClient.patch(
                    `/api/products-delivery-request/${contentTypeId}/${this.client.id}/`,
                    {
                        status: "rejected",
                        delivery_date: formattedDate,
                        description:
                            this.deliveryDescriptions[request.id] || "",
                    }
                );

                this.deliveryRequest.status = "rejected";
                this.deliveryRequest.delivery_date = formattedDate;
                this.$toast?.success(
                    "Solicitarea de livrare a fost respinsă cu o nouă dată."
                );
            } catch (err) {
                this.$toast?.error("Eroare la respingerea solicitării.");
                console.error("PATCH delivery rejection error:", err);
            } finally {
                this.showRejectDialog = false;
            }
        },
        /**
         * Updates the status of the most recent delivery request.
         * Uses PATCH request to send only the status field.
         *
         * @param {string} newStatus - The new status to apply ("approved" or "rejected").
         * @returns {Promise<void>}
         */
        async updateDeliveryStatus(newStatus, request) {
            if (!this.deliveryRequest?.id) {
                console.warn("Nu există nicio solicitare de livrare activă.");
                return;
            }

            try {
                const contentTypesRes = await apiClient.get(
                    "/api/content-types/"
                );
                const contentTypeId =
                    contentTypesRes.data.greenhousesolarclient;

                await apiClient.patch(
                    `/api/products-delivery-request/${contentTypeId}/${this.client.id}/`,
                    {
                        status: newStatus,
                        description:
                            this.deliveryDescriptions[request.id] || "",
                    }
                );

                this.deliveryRequest.status = newStatus;
                this.$toast?.success(
                    `Statusul livrării a fost actualizat la: ${newStatus}.`
                );
            } catch (err) {
                this.$toast?.error(
                    "Eroare la actualizarea statusului livrării."
                );
                console.error("PATCH delivery status error:", err);
            }
        },
        /**
         * Handles the approval flow for a delivery request.
         *
         * - If the delivery is marked as partial (`partialDeliveries[request.id]` is true),
         *   it sets the `partial_delivery` flag and updates the delivery status to `"pending"`.
         * - Otherwise, it directly sets the delivery status to `"approved"`.
        
         *
         * @async
         * @param {Object} request - The delivery request object being approved.
         * @returns {Promise<void>}
         */

        async approveDelivery(request) {
            // Optionally update partial_delivery flag
            if (this.partialDeliveries[request.id]) {
                await this.markPartialDeliveryTrue();
                await this.updateDeliveryStatus("pending_for_partial", request);
                await this.saveSuggestedDate(request);
                await sendDeliveryEmail({
                    scenario: "admin_partial",
                    client_id: this.client.id,
                    delivery_date: request.delivery_date,
                    actor: "admin",
                    description: request?.description || null,
                    partial_delivery:
                        this.partialDeliveries[request.id] || false,
                    test: false,
                });
                showAlertModal(
                    this.$store,
                    "Solicitarea de livrare partiala a fost transmisa",
                    "success",
                    5000
                );
            } else {
                await this.updateDeliveryStatus("approved", request);
                await sendDeliveryEmail({
                    scenario: "admin_approved",
                    client_id: this.client.id,
                    delivery_date: request.delivery_date,
                    actor: "admin",
                    description: request?.description || null,
                    partial_delivery:
                        this.partialDeliveries[request.id] || false,
                    test: false,
                });

                showAlertModal(
                    this.$store,
                    "Solicitarea de livrare a fost efectuata",
                    "success",
                    5000
                );
            }
        },

        /**
         * Marks the current delivery request as partial.
         * PATCHes partial_delivery: true.
         */
        async markPartialDeliveryTrue(requestId) {
            if (!requestId) return;

            try {
                const contentTypesRes = await apiClient.get(
                    "/api/content-types/"
                );
                const contentTypeId =
                    contentTypesRes.data.greenhousesolarclient;

                await apiClient.patch(
                    `/api/products-delivery-request/${contentTypeId}/${this.client.id}/`,
                    {
                        partial_delivery: this.partialDeliveries[requestId],
                    }
                );

                this.$toast?.info("Livrarea a fost actualizată ca parțială.");
            } catch (error) {
                console.error(
                    "Eroare la actualizarea livrării parțiale:",
                    error
                );
                this.$toast?.error("Nu s-a putut seta livrarea ca parțială.");
            }
        },
        /**
         * Checks if a delivery request is both approved and marked as partial.
         *
         * @param {Object} request - The delivery request to evaluate
         * @returns {boolean} - True if the request is approved and partial
         */
        isApprovedPartial(request) {
            return (
                request.status === "approved" &&
                this.partialDeliveries[request.id] === true
            );
        },
        /**
         * Returns a human-readable label for a delivery request status.
         *
         * - Handles special case for approved partial deliveries.
         * - Adds explanatory text for statuses that require agent approval.
         *
         * @param {string} status - The internal status code of the delivery request.
         * @param {number|string} requestId - The ID of the request, used to check partial delivery flag.
         * @returns {string} Localized status label for UI display.
         */
        getDeliveryStatusLabel(status, requestId) {
            if (status === "approved") {
                if (this.partialDeliveries[requestId]) {
                    return "Livrare parțială efectuată";
                }
                return "Livrare efectuată";
            }

            if (status === "rejected") {
                return "Livrare respinsă (necesită aprobare agent)";
            }

            if (status === "pending_for_partial") {
                return "Livrare parțială solicitată (necesită aprobare agent)";
            }

            // default or "pending"
            return "Livrare solicitată (necesită aprobare)";
        },
        async saveSuggestedDate(request) {
            if (!request?.id || !this.suggestedDeliveryDates[request.id]) {
                return;
            }

            try {
                const contentTypesRes = await apiClient.get(
                    "/api/content-types/"
                );
                const contentTypeId =
                    contentTypesRes.data.greenhousesolarclient;

                await apiClient.patch(
                    `/api/products-delivery-request/${contentTypeId}/${this.client.id}/`,
                    {
                        suggested_delivery_date: this.toISODate(
                            this.suggestedDeliveryDates[request.id]
                        ),
                    }
                );

                this.$toast?.success(
                    "Sugestia de livrare integrală a fost salvată."
                );
            } catch (error) {
                console.error(
                    "Eroare la salvarea sugestiei de livrare:",
                    error
                );
                this.$toast?.error("Nu s-a putut salva sugestia de livrare.");
            }
        },
        /**
         * Updates the suggested delivery date for a given request.
         * - Sets the internal date value (`suggestedDeliveryDates[requestId]`)
         * - Optionally formats and stores the display value
         * - Closes the calendar menu
         * - Persists the selected date to the backend API
         *
         * @param {string} date - The selected date in ISO format (YYYY-MM-DD)
         * @param {number|string} requestId - The unique ID of the delivery request
         * @param {Object} request - The delivery request object
         */
        updateSuggestedDate(date, requestId) {
            this.suggestedDeliveryDates[requestId] = date;

            // Optional: if using a formatted display
            if (this.formattedSuggestedDates) {
                this.formattedSuggestedDates[requestId] = new Date(
                    date
                ).toLocaleDateString("ro-RO");
            }

            this.suggestedDateMenus[requestId] = false;
        },
    },
};
</script>
<style>
.v-expansion-panel-title {
    background-color: #eee !important;
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
}
</style>
